import config         from "./config";
import Utilites       from "./utilites";
import WidgetsManager from "./widgets-manager";
import "./reset.css";
import injectTapEventPlugin from "react-tap-event-plugin";
injectTapEventPlugin();

const nebolitpro = Object.create(null);
nebolitpro.themes = WidgetsManager.themes;
nebolitpro._partnerId = 0; // Default partner id. Work like booking from https://nebolit.pro.
/**
 * @param  {number} partnerId
 */
nebolitpro.setPartnerId = function setPartnerId(partnerId) {
    nebolitpro._partnerId = partnerId;
};

/**
 * @param {string} theme
 */
nebolitpro.setTheme = function setTheme(theme) {

    let muiTheme = null;
    if (typeof theme === "string") {
        muiTheme = WidgetsManager.getTheme(theme);
        if (muiTheme === null) {
            throw new Error (`Theme ${theme} doesn't exists.`);
        }
    } else {
        muiTheme = theme;
    }

    WidgetsManager.setTheme(muiTheme);
};

nebolitpro.setAllowOverriding = function setAllowOverriding(value) {
    WidgetsManager.setAllowOverriding(value);
};



/**
 * AppointmentWidget - create
 * @param  {DOMNode} DOMNode
 * @param  {object} props
 * @return {Promise}
 */
nebolitpro.creteAppointmentWidget = function creteAppointmentWidget(DOMNode, props) {
    return WidgetsManager.create("AppointmentWidget", DOMNode, props);
};

/**
 * AppointmentWidget - show
 * @param  {DOMNode} DOMNode
 * @param  {object} props
 * @return {Promise}
 */
nebolitpro.showAppointmentWidget = function showAppointmentWidget(DOMNode, props) {
    /* TODO find DOM node... */
    return WidgetsManager.call("AppointmentWidget", "show", true, DOMNode, props);
};

/**
 * AppointmentWidget - hide
 * @param  {DOMNode} DOMNode
 * @param  {object} props
 * @return {Promise}
 */
nebolitpro.hideAppointmentWidget = function hideAppointmentWidget(DOMNode) {
    return WidgetsManager.call("AppointmentWidget", "hide", false, DOMNode, null);
};

document.addEventListener("DOMContentLoaded", function () {
    const widgetDOMNodes = document.querySelectorAll("[data-widget]");
    for (let i = 0; i < widgetDOMNodes.length; i++) {
        const props = Utilites.parseProps(widgetDOMNodes[i]);
        if (props === null)  {
            continue;
        }

        const widgetName = Utilites.normalizeWidgetName(widgetDOMNodes[i].getAttribute("data-widget"));
        let allowOverriding = false;

        if (widgetDOMNodes[i].hasAttribute("data-allow-overriding")) {
            const value = widgetDOMNodes[i].getAttribute("data-allow-overriding");
            if (value !== "0" && value !== "false") {
                allowOverriding = true;
            }
        }

        if (WidgetsManager.staticWidgets.indexOf(widgetName) !== -1) {
            WidgetsManager.create(widgetName, widgetDOMNodes[i], props, allowOverriding).catch((error) => {
                console.warn(error);
            });
        } else {
            const mountPoint = document.createElement("div");
            mountPoint.className = `${WidgetsManager.getNamespace()}-container`;
            document.body.appendChild(mountPoint);

            WidgetsManager.create(widgetName, mountPoint, props, allowOverriding, widgetDOMNodes[i]).then((reference) => {
                widgetDOMNodes[i].addEventListener("click", function (event) {
                    reference.show();
                });
            }).catch((error) => {
                console.warn(error);
            });
        }
    }
});

// Yandex metrika
(function (d, w, c) {
    (w[c] = w[c] || []).push(function() {
        try {
            w.nebolitpro.yandexCounter = new Ya.Metrika(config.yandexMetrikaConfig); // eslint-disable-line
        } catch(e) { console.warn(e.message); }
    });

    var n = d.getElementsByTagName("script")[0],
        s = d.createElement("script"),
        f = function () { n.parentNode.insertBefore(s, n); };

    s.type = "text/javascript";
    s.async = true;
    s.src = "https://mc.yandex.ru/metrika/watch.js";

    if (w.opera === "[object Opera]") {
        d.addEventListener("DOMContentLoaded", f, false);
    } else { f(); }
})(document, window, "yandex_metrika_callbacks");

window.nebolitpro = nebolitpro;


/** WEBPACK FOOTER **
 ** ./src/index.js
 **/